import Stack from '@mui/material/Stack';

import styled from 'shared/utils/styled';

export namespace Styled {
  export const Container = styled(Stack)(({ theme }) => ({
    padding: '10px',
    border: '1px dashed',
    borderColor: theme.palette.primary.main,
  }));

  export const Wrapper = styled('div')(() => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '10px 50px',
  }));

  export const Label = styled('span')(({ theme }) => ({
    fontSize: theme.typography.pxToRem(15),
    fontWeight: 600,
    lineHeight: 1,
  }));
}
